import { render } from "./IconLoading.vue?vue&type=template&id=9298348a&scoped=true"
import script from "./IconLoading.vue?vue&type=script&lang=js"
export * from "./IconLoading.vue?vue&type=script&lang=js"

import "./IconLoading.vue?vue&type=style&index=0&id=9298348a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9298348a"]])

export default __exports__